module.exports = __webpack_public_path__ + "img/trash_icon.452ef639.svg";